"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const format_currency_1 = require("@App/helpers/format-currency");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const RightsholderRoyaltiesPayeeDownloadLink_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesPayeeDownloadLink"));
require("../index.scss");
const SummaryTable = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { data, openStatusSidebar, period } = props;
    return (react_1.default.createElement("div", { className: "royalties-table summary-table" },
        react_1.default.createElement("table", null,
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, "Publisher Number"),
                    react_1.default.createElement("th", null, "Payee Name"),
                    react_1.default.createElement("th", null, "Opening Balance"),
                    react_1.default.createElement("th", null, "Royalties in Period"),
                    react_1.default.createElement("th", null, "Payable Amount"),
                    react_1.default.createElement("th", null, "Amount Paid"),
                    react_1.default.createElement("th", null, "Closing Balance"),
                    react_1.default.createElement("th", null, "Payment Status"),
                    react_1.default.createElement("th", null, "Payee Activity"),
                    react_1.default.createElement("th", null, "Statements")),
                data.map((row, index) => (react_1.default.createElement("tr", { key: index },
                    react_1.default.createElement("td", null, row.publisherNumber),
                    react_1.default.createElement("td", { className: 'bold' }, row.payeeName),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("div", { className: 'currency' },
                            react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(row.openingBalanceAmount)))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("div", { className: 'currency' },
                            react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(row.royaltiesAmount + row.adjustmentsAmount)))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("div", { className: 'currency' },
                            react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(row.payableBalanceAmount)))),
                    react_1.default.createElement("td", { className: 'paid' },
                        react_1.default.createElement("div", { className: 'currency' },
                            react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(row.paymentAmount)))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("div", { className: 'currency' },
                            react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(row.closingBalanceAmount)))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("a", { className: 'small', onClick: () => openStatusSidebar && openStatusSidebar(row.statusUpdates) }, row.status)),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(RightsholderRoyaltiesPayeeDownloadLink_1.default, { payeeRoyalties: row, useNewLink: true })),
                    react_1.default.createElement("td", { className: 'no-right-border' },
                        react_1.default.createElement("a", { className: 'small', onClick: () => {
                                var _a;
                                return navigate(navigation_1.default.rightholder.royalties.statement(rightsholderStore.currentRightsholderId, row.ipId, (_a = period === null || period === void 0 ? void 0 : period.label) !== null && _a !== void 0 ? _a : ''));
                            } }, "View")))))))));
};
exports.default = SummaryTable;
